export const COMPANY_NAME = "Asiduo Enterprises";

export const navigationLinks = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Products", path: "/products" },
  { label: "Services", path: "/services" },
  { label: "Industries", path: "/industries" },
  { label: "Contact", path: "/contact" },
  { label: "Request Quote", path: "/request-quote" }
];

export const productCategories = [
  { label: "Export", value: "export" },
  { label: "Import", value: "import" },
  { label: "Technical", value: "technical" }
];

export const industries = [
  "Food & Agriculture",
  "Retail Distribution",
  "Industrial Infrastructure",
  "Oil & Gas",
  "Hospitality",
  "Pet Care"
];

export const services = [
  "Global sourcing and procurement",
  "Export documentation and compliance",
  "Import coordination and customs support",
  "Private labeling and packaging advisory",
  "Industrial technical procurement",
  "End-to-end logistics consultation"
];
